"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateSysRoot = exports.generateSocialNetworkFieldValue = exports.getSocialNetworkFieldEmptyValue = void 0;
const getSocialNetworkFieldEmptyValue = () => {
    return {
        facebook_username: "",
        linkedin_username: "",
        instagram_username: "",
        twitter_username: "",
        sys_root: "",
    };
};
exports.getSocialNetworkFieldEmptyValue = getSocialNetworkFieldEmptyValue;
const generateSocialNetworkFieldValue = (value) => {
    return { ...(0, exports.getSocialNetworkFieldEmptyValue)(), ...value };
};
exports.generateSocialNetworkFieldValue = generateSocialNetworkFieldValue;
const generateSysRoot = (value) => {
    const nestedSlugs = [
        "fb",
        "tw",
        "li",
        "ig",
    ];
    const sysRootParts = nestedSlugs
        .map((part) => value[part])
        .filter((part) => !!part);
    return sysRootParts.join(", ");
};
exports.generateSysRoot = generateSysRoot;
